//Import Styles
import "./../scss/style.scss"
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/navigation";

//Import Scripts
import Menu from "./modules/Menu";
import Accordion from "./modules/Accordion";
import Slider from "./modules/Slider";
import Messages from "./modules/Messages";

window.addEventListener('DOMContentLoaded', () => {
  Menu();
  Accordion();
  Slider();
  Messages();
});
